import React from 'react';

import {OEFNWelcomeEntryTypes} from '../../views/flow-nav/welcome/oe-fn-welcome-model';
import OEProtoStartView, {OEProtoStartViewEntryTypes} from '../oe-proto-start-view';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OESchoolTargetType, OESchoolTargets, OESchoolFeatureAccess, OESchoolStartSelectionData} from './oe-school-model';
import {OEFlowNavModalFlags} from '../../views/flow-nav/oe-flow-nav-modal';

export default class OESchoolStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        let modules = OESchoolStartSelectionData.chooseModules();

        let targetTypeEntries = [
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OESchoolTargetType.biology, stringId: 'target_menu_biology', icon: OEIconCodes.school.biologyTarget, spacerHeight: '1.25em', className: 'biology-entry'},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OESchoolTargetType.chemistry, stringId: 'target_menu_chemistry', icon: OEIconCodes.school.chemistryTarget, spacerHeight: '1.25em', className: 'chemistry-entry'},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OESchoolTargetType.geography, stringId: 'target_menu_geography', icon: OEIconCodes.school.geographyTarget, spacerHeight: '1.25em', className: 'geography-entry'},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OESchoolTargetType.physics, stringId: 'target_menu_physics', icon: OEIconCodes.school.physicsTarget, spacerHeight: '1.25em', className: 'physics-entry'},
            {type: OEProtoStartViewEntryTypes.targetType, targetType: OESchoolTargetType.math, stringId: 'target_menu_math', icon: OEIconCodes.school.mathTarget, spacerHeight: '1.25em', className: 'math-entry'},
        ].filter(entry => modules.findIndex(module => module.id === entry.targetType) >= 0);

        this.entries = [
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: true}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '3.375em' /*54*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_module_selection', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                ...targetTypeEntries,
                {type: OEFNWelcomeEntryTypes.spacer, height: '2em' /*32*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1em' /*16*/}
            ]},
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: false}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '3.375em' /*54*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                ...targetTypeEntries,
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.5em' /*24*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_module_notice_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1em' /*16*/},
                {type: OEFNWelcomeEntryTypes.button, stringId: 'welcome_view_website', linkId: 'welcome_view_website_link'},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.75em' /*28*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1em' /*16*/}
            ]},
            {type: OEFNWelcomeEntryTypes.help, stringId: 'welcome_view_help_target_menu', className: 'help-entry', flowNavModalFlags: OEFlowNavModalFlags.closeOnToggle},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.5em' /*24*/}
        ];
    }

    render()    {
        return (
            <OEProtoStartView
                {...this.props}
                entries={this.entries}
                versionTargets={OESchoolTargets}
                featureAccess={OESchoolFeatureAccess}
                startSelectionData={OESchoolStartSelectionData}
            />
        );
    }
}